import React, { ComponentType, RefObject } from "react";
import { Grid } from "@material-ui/core";
import { useDimensions } from "../../../hooks/dimensions.hook";

import classes from './index.module.scss';


export interface CanvasChildrenProps {
  containerHeight?: number,
  containerWidth?: number,
}

interface CanvasProps {
  mapContainer?: RefObject<HTMLDivElement>,
  reactComponent: ComponentType<CanvasChildrenProps>,
  minHeight?: number,
}

const CanvasContainer = ({ minHeight, reactComponent }: CanvasProps) => {
  const mapContainer = useDimensions();
  const height = Math.max(mapContainer.dimensions.height, minHeight || 0);
  const width = mapContainer.dimensions.width;

  return (
    <Grid
      container
      className={classes.mapContainer}
      ref={mapContainer.elementRef}
    >
      <main
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
        }}
      >
        <svg
          height={height}
          width={width}
          viewBox={`0 0 ${width} ${height}`}
        >
          {
            React.createElement(reactComponent, { containerHeight: height, containerWidth: width })
          }
        </svg>
      </main>
    </Grid>
  )
}

export default CanvasContainer;